import apiClient from "../axios.config";

const propertyService = {
  // ✅ Get distinct properties
  getDistinctProperties() {
    return apiClient.get("/owner/properties/distinct");
  },
};

export default propertyService;
